export default "__VITE_ASSET__LtdSAAj___"